module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/play-video-aa20da86378a71935c6ce5ae543b4aea.png";